import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {},
  fields: {
    // we're controling the grid's row spacing
    // because HvGrid still doesn't support it to
    // be different from the column spacing.
    "$root&>div>div>label": {
      height: "22px",
      marginBottom: "0px",
      display: "block",
    },
  },
  gridPaddingOverRide: {
    padding: "0 15px",
  },
  gridHeight: {
    height: "86px",
  },
}));

export default useStyles;
